import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import api from "../../../services/api";
import SelectUser from "../../../components/selectUser";
import Select from "../../../components/Select";

const Edit = ({ onSave, device }) => {
  const [loading, setLoading] = useState(false);
  const [businessUnits, setBusinessUnits] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/business_unit").then(({ data, ok }) => { if (ok) setBusinessUnits(data); });
  }, []);

  const onDelete = async () => {
    try {
      if (!window.confirm("Are you sure you want to delete this device?")) return;
      await api.remove(`/device/${device._id}`);
      toast.success("Device deleted");
      navigate("/device");
    } catch (e) {
      console.log(e);
      toast.error("Error deleting device");
    }
  };

  async function submit() {
    if (device.status === "not available" && !device.userName) return toast.error("Please select a user");
    if (device.status === "available" && !device.office) return toast.error("Please select an office");
    if (!device.serial_number) return toast.error("Please enter a serial number");

    setLoading(true);
    const deviceData = { ...device };
    if (deviceData.userId === undefined) {
      deviceData.userId = null;
    }
    if (deviceData.userName === undefined) {
      deviceData.userName = null;
    }
    try {
      const { data, ok } = await api.put(`/device/${device._id.toString()}`, deviceData);
      if (!ok) return toast.error(data.error);
      setLoading(false);
      toast.success("Updated");
      onSave(data);
    } catch (e) {
      toast.error("Error updating device");
    }
  }

  if (!device) return null;

  return (
    <div className="w-full h-auto bg-[white] p-[25px] rounded-md grid grid-cols-1 gap-2">
      <input
        className="border border-gray-300 px-2 py-1"
        placeholder="Name"
        value={device.name || ""}
        onChange={(e) => {
          onSave({ ...device, name: e.target.value });
        }}
      />
      <input
        className="border border-gray-300 px-2 py-1"
        placeholder="Model"
        value={device.model || ""}
        onChange={(e) => {
          onSave({ ...device, model: e.target.value });
        }}
      />
      <input
        className="border border-gray-300 px-2 py-1"
        placeholder="serial_number"
        value={device.serial_number || ""}
        onChange={(e) => {
          onSave({ ...device, serial_number: e.target.value });
        }}
      />
      <div className="mt-4 grid grid-cols-2 gap-4">
        <div>
          <p>RAM</p>
          <input
            className="border border-gray-300 px-2 py-1 mt-2 w-full"
            type="text"
            placeholder="RAM"
            value={device.ram || ""}
            onChange={(e) => {
              onSave({ ...device, ram: e.target.value });
            }}
          />
        </div>
        <div>
          <p>Storage</p>
          <input
            className="border border-gray-300 px-2 py-1 mt-2 w-full"
            type="text"
            placeholder="Storage"
            value={device.storage || ""}
            onChange={(e) => {
              onSave({ ...device, storage: e.target.value });
            }}
          />
        </div>
        <div>
          <p>Keyboard layout</p>
          <select
            className="border border-gray-300 px-2 py-1 mt-2 w-full"
            value={device.keyboard_layout || ""}
            onChange={(e) => {
              onSave({ ...device, keyboard_layout: e.target.value });
            }}>
            <option value="">Choose a keyboard layout</option>
            {["AZERTY", "QWERTY", "QWERTZ", "QWERTY (US)", "QWERTY (UK)", "QWERTY (Dutch)"].map((option, i) => (
              <option key={`option-keyboard-layout-${i}`} label={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      </div>
      <p className="mt-4">is the device active (used by someone) ?</p>
      <select
        className="border border-gray-300 px-2 py-1"
        placeholder="status"
        value={device.status || ""}
        onChange={(e) => {
          onSave({
            ...device,
            status: e.target.value,
            userId: e.target.value === "not available" ? device.userId : null,
            userName: e.target.value === "not available" ? device.userName : null,
            userAvatar: e.target.value === "not available" ? device.userAvatar : null,
            office: e.target.value === "available" ? device.office : null,
          });
        }}>
        <option label="Choose status" value="" disabled>
          Choose Status
        </option>
        {["not available", "available", "lost"].map((option, i) => (
          <option key={`option-status-${i}`} label={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      {device.status === "not available" && (
        <>
          <p className="mt-2">who ?</p>
          <SelectUser 
            value={device.userId ? {
              _id: device.userId,
              name: device.userName,
              avatar: device.userAvatar
            } : null} 
            onChange={(u) => onSave({ ...device, userId: u._id, userName: u.name, userAvatar: u.avatar })} 
          />
        </>
      )}
      {device.status === "available" && (
        <>
          <p className="mt-2">Office where the device is stored :</p>
          <select
            className="border border-gray-300 px-2 py-1"
            placeholder="status"
            value={device.office || ""}
            onChange={(e) => {
              onSave({
                ...device,
                office: e.target.value,
              });
            }}>
            <option label="Choose an office" value="" disabled>
              Choose an office :
            </option>
            <option value="Paris">Paris</option>
            <option value="Amsterdam">Amsterdam</option>
            <option value="Barcelone">Barcelone</option>
          </select>
        </>
      )}
      <div className="mt-4">
        <p className="mb-1">Business Unit</p>
        <Select
          options={[{ _id: "", name: "-" }, ...businessUnits.map((bu) => ({ _id: bu._id, name: `${bu.emoji || ""} ${bu.name}`.trim() }))]}
          value={businessUnits.find((bu) => bu._id === device.business_unit_id) ? { _id: device.business_unit_id, name: businessUnits.find((bu) => bu._id === device.business_unit_id)?.name } : null}
          onChange={(e) => {
            const bu = businessUnits.find((b) => b._id === e._id);
            onSave({ ...device, business_unit_id: e._id || "", business_unit_name: bu?.name || "" });
          }}
          placeholder="Business Unit"
          width="w-full"
          getValue={(v) => v._id}
          getLabel={(v) => v.name}
        />
      </div>
      <p className="mt-4">comments (when/where is was bought, where it is stored, specificities, known issues, other...) :</p>
      <textarea
        className="border border-gray-300 px-2 py-1"
        placeholder="comments"
        value={device.comments || ""}
        onChange={(e) => {
          onSave({ ...device, comments: e.target.value });
        }}
      />
      <div className="mt-4">
        <p>Device Purchase Date</p>
        <input
          className="border border-gray-300 px-2 py-1 mt-2"
          type="date"
          value={device?.purchase_date && new Date(device?.purchase_date).toISOString().split("T")[0]}
          onChange={(e) => {
            onSave({ ...device, purchase_date: e.target.value && new Date(e.target.value) });
          }}
        />
      </div>
      <div className="flex gap-2 mt-4 justify-end">
        <button
          disabled={loading}
          className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 disabled:opacity-40 disabled:cursor-not-allowed"
          onClick={onDelete}>
          Delete
        </button>
        <button
          disabled={loading}
          className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 disabled:opacity-40 disabled:cursor-not-allowed"
          onClick={submit}>
          {loading ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default Edit;
